angular.module('impactx.quota').controller('QuotaStatListCtrl',
    QuotaStatListCtrl);

function QuotaStatListCtrl()
{
    this.meta = {
        rowTemplate: 'modules/quota/templates/quotastatlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/quota/liststat',
        id: "quotastatlist",
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}